import { AreaChart, Area, ResponsiveContainer } from 'recharts';

export function Sparkline({ data = [], color = '#6366f1', height = 40 }) {
  if (!data || data.length < 2) return null;
  const normalized = data.map((v, i) =>
    typeof v === 'number' ? { v } : { v: v?.value ?? v?.sessions ?? v?.count ?? 0 }
  );
  return (
    <ResponsiveContainer width="100%" height={height}>
      <AreaChart data={normalized} margin={{ top: 2, right: 2, bottom: 2, left: 2 }}>
        <defs>
          <linearGradient id={`sg-${color.replace('#', '')}`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor={color} stopOpacity={0.25} />
            <stop offset="95%" stopColor={color} stopOpacity={0} />
          </linearGradient>
        </defs>
        <Area
          type="monotone"
          dataKey="v"
          stroke={color}
          strokeWidth={1.5}
          fill={`url(#sg-${color.replace('#', '')})`}
          dot={false}
          isAnimationActive={false}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}
